export default {

  init() {

    $('.tour__menu button').on('click', function(e) {
      e.preventDefault();

      let $tab = $(this);
      let $parent = $tab.parent();
      let $group = $tab.parents('.tour').first();
      let $pane = $('#'+$tab.attr('aria-controls'));

      if(!$pane.length) {
        return;
      }

      $group.find('.tour__menu button').attr('aria-selected', 'false');
      $tab.attr('aria-selected', 'true');

      $group.find('.tour__menu li').removeClass('is-active');
      $parent.addClass('is-active');

      $group.find('.tour__slide').removeClass('is-active');
      $pane.addClass('is-active');
    });
  }

};
